<template>
  <div class="total bgps flex fd">
    <theader />
    <div class="content f1 flex">
      <div class="left flex fd">
        <bluetitle :titlearr="[{ label: '预警记录', select: 1 }]"  />
        <div class="flex fd" style="padding: 0 1.04vw; gap: 0.83vw; height: 37vw;overflow: auto;">
          <div class="shotsingle flex ac pr" v-for="(i, j) in shotlist">
            <img src="../assets/image/environment/扬尘.png" alt="" v-if="i.alarmDescription.indexOf('尘') > -1" />
            <img src="../assets/image/environment/噪音.png" alt="" v-else-if="i.alarmDescription.indexOf('噪') > -1" />
            <img src="../assets/image/environment/风力.png" alt="" v-else-if="i.alarmDescription.indexOf('风') > -1" />
            <img src="../assets/image/environment/降水.png" alt="" v-else-if="i.alarmDescription.indexOf('水') > -1" />
            <img src="../assets/image/environment/温度.png" alt="" v-else />
            <div class="flex fd jb" style="color: white">
              <p style="font-size: 0.89vw; margin-bottom: 0.52vw">
                {{ i.alarmType }}
              </p>
              <div style="color: #bbc6d6">
                <p>预警阈值：{{i.thresholdValue}}</p>
                <p style="margin-bottom: 0.42vw">
                  实际值：{{ i.realTimeValue }}
                  <span v-if="i.alarmDescription.indexOf('尘') > -1">μg/m³</span>
                  <span v-else-if="i.alarmDescription.indexOf('噪') > -1">dB</span>
                  <span v-else-if="i.alarmDescription.indexOf('风') > -1">级</span>
                  <span v-else-if="i.alarmDescription.indexOf('水') > -1">mm</span>
                  <span v-else>°C</span>
                </p>
                <p>{{ i.alarmTime }}</p>
              </div>
            </div>
            <div class="pa flex jc ac" style="
                width: 4.48vw;
                height: 1.72vw;
                background: linear-gradient(56deg, #f3ae42 0%, #9c5c15 100%);
                border-radius: 0px 0.42vw 0px 0.73vw;
                top: 0;
                right: 0;
                color: white; "
                 :class="{'handled' : i.isHandling === '已处理' }" >
              {{ i.isHandling }}
            </div>
          </div>
            <div class="kongbox" v-if="shotlist.length===0">
                <img src="../assets/image/暂无数据@2x.png" alt="" />
                <p>暂无项目数据</p>
              </div>
        </div>
      </div>
      <div class="right f1 flex fd">
        <div class="f1 flex" style="gap: 1.04vw">
          <div class="f1 topsingle">
            <bluetitle :titlearr="[{ label: 'PM2.5', select: 1 }]" />
            <div class="jindu">
              <div class="biaoti">
                <p>国控值</p>
                <p>
                  <span>{{ datas.pm25NationalStandard }}</span>
<!--                  <font>/100</font>-->
                </p>
              </div>
              <div class="jindutiao">
                <div class="chang" :style="`width: ${datas.pm25NationalStandard}%;`"
                  style="background: linear-gradient( 270deg, #00d5ff 0%, rgba(0,192,254,0) 100%);"></div>
                <div class="dian" :style="`left: ${(datas.pm25NationalStandard - 2) > 0 ? (datas.pm25NationalStandard - 2) : 0}%;`"
                  style="background: #00E7FE;"></div>
              </div>
            </div>
            <div class="jindu">
              <div class="biaoti">
                <p>实时值</p>
                <p>
                  <span>{{ datas.pm25 }}</span>
<!--                  <font>/100</font>-->
                </p>
              </div>
              <div class="jindutiao">
                <div class="chang" :style="`width: ${datas.pm25}%;`"
                  style="width: 50%;background: linear-gradient( 270deg, #00FE83 0%, rgba(0,254,131,0) 100%);"></div>
                <div class="dian" :style="`left: ${datas.pm25 - 2>0?datas.pm25 - 2:0}%;`" style="left: 48%;background: #00ff4c;"></div>
              </div>
            </div>
            <div class="junzhi">
              <div>
                <p>{{ datas.pm25LastHourAvg ? datas.pm25LastHourAvg : "-" }}</p>
                <span>小时均值</span>
              </div>
              <div>
                <p>{{ datas.pm25MorningAvg ? datas.pm25MorningAvg : "-" }}</p>
                <span>上午均值</span>
              </div>
              <div>
                <p>{{ datas.pm25AfternoonAvg == null ? '-' : datas.pm25AfternoonAvg }}</p>
                <span>下午均值</span>
              </div>
              <div>
                <p>{{ datas.pm25DailyAvg ? datas.pm25DailyAvg : "-" }}</p>
                <span>日均值</span>
              </div>
            </div>
          </div>
          <div class="f1 topsingle">
            <bluetitle :titlearr="[{ label: 'PM10', select: 1 }]" />
            <div class="jindu">
              <div class="biaoti">
                <p>国控值</p>
                <p>
                  <span>{{ datas.pm10NationalStandard }} </span>
<!--                  <font>/100</font>-->
                </p>
              </div>
              <div class="jindutiao">
                <div class="chang" :style="`width: ${datas.pm10NationalStandard}%;`"
                  style="background: linear-gradient( 270deg, #00d5ff 0%, rgba(0,192,254,0) 100%);"></div>
                <div class="dian" :style="`left: ${datas.pm10NationalStandard - 2>0?datas.pm10NationalStandard - 2>0:0}%;`" style="background: #00E7FE;"></div>
              </div>
            </div>
            <div class="jindu">
              <div class="biaoti">
                <p>实时值</p>
                <p>
                  <span>{{ datas.pm10 }} </span>
<!--                  <font>/100</font>-->
                </p>
              </div>
              <div class="jindutiao">
                <div class="chang" :style="`width: ${datas.pm10}%;`"
                  style="background: linear-gradient( 270deg, #00FE83 0%, rgba(0,254,131,0) 100%);"></div>
                <div class="dian" :style="`left: ${datas.pm10 - 2>0?datas.pm10 - 2:0}%;`" style="background: #00ff4c;"></div>
              </div>
            </div>
            <div class="junzhi">
              <div>
                <p>{{ datas.pm10LastHourAvg?datas.pm10LastHourAvg:'-' }}</p>
                <span>小时均值</span>
              </div>
              <div>
                <p>{{ datas.pm10MorningAvg?datas.pm10LastHourAvg:'-' }}</p>
                <span>上午均值</span>
              </div>
              <div>
                <p>{{ datas.pm10AfternoonAvg == null ? '-' : datas.pm10AfternoonAvg }}</p>
                <span>下午均值</span>
              </div>
              <div>
                <p>{{ datas.pm10DailyAvg?datas.pm10LastHourAvg:'-' }}</p>
                <span>日均值</span>
              </div>
            </div>
          </div>
          <div class="f1 flex fd" style="gap: 1.04vw">
            <div class="f1 topsingle">
              <bluetitle :titlearr="[{ label: 'TSP', select: 1 }]" />
              <div class="jindu" style="height: 70%;">
                <div class="biaoti" style="height: 50%;">
                  <p>实时值</p>
                  <p>
                    <span>{{ datas.tsp }} </span>
<!--                    <font>/100</font>-->
                  </p>
                </div>
                <div class="jindutiao">
                  <div class="chang" :style="`width: ${datas.tsp}%;`"
                    style="background: linear-gradient( 270deg, #00d5ff 0%, rgba(0,192,254,0) 100%);"></div>
                  <div class="dian" :style="`left: ${datas.tsp - 2>0?datas.tsp - 2:0}%;`" style="background: #00E7FE;"></div>
                </div>
              </div>
            </div>
            <div class="f1 topsingle">
              <bluetitle :titlearr="[{ label: '噪声', select: 1 }]" />
              <div class="jindu" style="height: 70%;">
                <div class="biaoti" style="height: 50%;">
                  <p>实时值</p>
                  <p>
                    <span>{{ datas.noise }} </span>
<!--                    <font>/100</font>-->
                  </p>
                </div>
                <div class="jindutiao">
                  <div class="chang" :style="`width: ${datas.noise}%;`"
                    style="background: linear-gradient( 270deg, #00d5ff 0%, rgba(0,192,254,0) 100%);"></div>
                  <div class="dian" :style="`left: ${datas.noise - 2>0?datas.noise - 2:0}%;`" style="background: #00E7FE;"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="f1 topsingle">
            <bluetitle :titlearr="[{ label: '实时气候', select: 1 }]" />
            <div class="biaotou" style="height: 13%;">
              <div>风向</div>
              <div>{{ datas.windDirectionStr }}</div>
            </div>
            <div class="jindu" style="height: 22%;">
              <div class="biaoti">
                <p>湿度 单位：%RH</p>
                <p>
                  <span>{{ datas.humidity }} </span>
<!--                  <font>/100</font>-->
                </p>
              </div>
              <div class="jindutiao">
                <div class="chang" :style="`width: ${datas.humidity}%;`"
                  style="background: linear-gradient( 270deg, #00FE83 0%, rgba(0,254,131,0) 100%);"></div>
                <div class="dian" :style="`left: ${datas.humidity - 2>0?datas.humidity - 2:0}%;`" style="top: -3px;background: #00ff4c;"></div>
              </div>

            </div>
            <div class="jindu" style="height: 22%;">
              <div class="biaoti">
                <p>风速 单位：m/s</p>
                <p>
                  <span>{{ datas.windSpeed }}</span>
<!--                  <font>/100</font>-->
                </p>
              </div>
              <div class="jindutiao">
                <div class="chang" :style="`width: ${datas.windSpeed}%;`"
                  style="background: linear-gradient( 270deg, #00d5ff 0%, rgba(0,192,254,0) 100%);"></div>
                <div class="dian" :style="`left: ${datas.windSpeed - 2>0?datas.windSpeed - 2:0}%;`" style="top: -3px; background: #00E7FE;"></div>
              </div>
            </div>

            <div class="jindu" style="height: 22%;">
              <div class="biaoti">
                <p>温度 单位：μg/m³</p>
                <p>
                  <span>{{ datas.temperature }}</span>
<!--                  <font>/100</font>-->
                </p>
              </div>
              <div class="jindutiao">
                <div class="chang" :style="`width: ${datas.temperature}%;`"
                  style="background: linear-gradient( 270deg, #EB9B1F 0%, rgba(0,192,254,0) 100%);"></div>
                <div class="dian" :style="`left: ${datas.temperature - 2>0?datas.temperature - 2:0}%;`" style="top: -3px;background: #EB9B1F;">
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="f1 flex fd">
          <div class="flex jb pr">
            <longbluetitle :titlearr="['扬尘趋势分析']" />
            <tabs :namelist="[
              { label: 'PM2.5', value: '' },
              { label: 'PM10', value: '' },
              { label: '噪音', value: '' },
            ]" class="pa" @tabnum="tabnum" style="top: 0; right: 0; width: 10.42vw" />
          </div>
          <div class="f1 rc">
            <div id="main" style="
          width: 100%;
          height: 10.5vw;
        "></div>
          </div>
        </div>
        <div class="f1 flex fd">
          <div class="flex jb pr">
            <longbluetitle :titlearr="['气候趋势分析']" />
            <tabs :namelist="[
              { label: '温度', value: '' },
              { label: '降水', value: '' },
              { label: '风力风向', value: '' },
            ]" class="pa" @tabnum="tabnum1" style="top: 0; right: 0; width: 10.42vw" />
          </div>
          <div class="f1 rc weart">
            <div class="head">
              <div v-for="(v, i) in dayarr" :key="i">
                <p>{{ v.daydata }}</p>
                <div>
                  <i :class="'qi-' + v.iconData"></i>
                </div>
              </div>
            </div>
            <div id="weather"></div>
            <div class="bott">
              <div v-for="(v, i) in windarr" :key="i">
                <p>＜{{ v.windSpeedNight }}级</p>
                <div class="winBox" :style="{background: v.windSpeedNight == 3 ?'#17B879':'#E69C3D'}">
                  {{ v.windSpeedNight == 3 ? '优' : '良' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <tmenu />
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      shotlist: [
        {
          type: "扬尘预警",
          address: "实际值：55.4 μg/m³",
          time: "2024/01/19 16:35:52",
          alarmDescription:'',
          value: "31μg/m³",
          icon: require("../assets/image/environment/扬尘.png"),
        },
        {
          type: "噪音预警",
          address: "31dB",
          value: "31dB",
          alarmDescription:'',
          time: "2024/01/19 16:35:52",
          icon: require("../assets/image/environment/噪音.png"),
        },
        {
          type: "风力预警",
          address: "实际值：5级",
          value: "5级",
          alarmDescription:'',
          time: "2024/01/19 16:35:52",
          icon: require("../assets/image/environment/风力.png"),
        },
        {
          type: "降水预警",
          address: "实际值：800mm",
          value: "800mm",
          alarmDescription:'',
          time: "2024/01/19 16:35:52",
          icon: require("../assets/image/environment/降水.png"),
        },
        {
          type: "温度预警",
          address: "实际值：-5°C～37°C",
          value: "-5°C～37°C",
          alarmDescription:'',
          time: "2024/01/19 16:35:52",
          icon: require("../assets/image/environment/温度.png"),
        },
      ],
      datas: {},
      dayarr: [],
      windarr: [],
      wendiList: [], //温度低
      wengaoList: [], //温度高
      wartdiList: [], //降水
      fengdiList: [], //风向
      wartgaoList: [], //降水
      fenggaoList: [], //风向
      activeTab: 0, // 默认选中"PM2.5"
      pm25List: [], //pm25
      pm10List: [], //pm10
      noiseList:[],
      noiseStandard:[],
      pm10Standard: [],
      pm25Standard: [],
      ymax: 120,
      echartsObj: {
        thresholdDatas: [],
        allDatas: [],
        yAxisName: "μg/m³",
        seriesName1: "PM2.5",
        seriesName2: 'PM2.5国控值',
      },
      weatherobj: {
        didata: [],
        gaodata: [],
        max:0,
        min:0
      }
    };
  },
  mounted() {
    this.getList()
    this.getNoiseEcharts()
    this.getweatherEcharts()
    this.getalarm()
  },
  methods: {
    tabnum1(e) {
      if (e == 0) {

        this.weatherobj.didata = this.wendiList
        this.weatherobj.gaodata = this.wengaoList

        this.weatherobj.min = Math.min(...this.wendiList) -5
        this.weatherobj.max = Math.max(...this.wengaoList)+5
        this.weatherobj.text="温度"

      } else if (e == 1) {
        this.weatherobj.didata = this.wartdiList
        this.weatherobj.gaodata = this.wartgaoList

        this.weatherobj.min = Math.min(...this.wartdiList)-3
        this.weatherobj.max = Math.max(...this.wartdiList)+3

        this.weatherobj.text="降水"

      } else if (e == 2) {
        this.weatherobj.didata = this.fengdiList
        this.weatherobj.gaodata = this.fenggaoList

        this.weatherobj.min = Math.min(...this.fengdiList)-3
        this.weatherobj.max = Math.max(...this.fenggaoList)+3

        this.weatherobj.text="风力风向"
      }

      this.weatherCharts(this.weatherobj)
    },
    tabnum(e) {
      console.log(e);
      this.activeTab = e
      if (e == 0) {
        this.echartsObj.thresholdDatas = this.pm25Standard
        this.echartsObj.allDatas = this.pm25List
        this.echartsObj.yAxisName = "μg/m³",
          this.echartsObj.seriesName1 = "PM2.5",
          this.echartsObj.seriesName2 = 'PM2.5国控值'
        this.ymax = 120
      } else if (e == 1) {
        this.echartsObj.thresholdDatas = this.pm10Standard
        this.echartsObj.allDatas = this.pm10List
        this.echartsObj.yAxisName = "μg/m³",
          this.echartsObj.seriesName1 = "PM10",
          this.echartsObj.seriesName2 = 'PM10国控值'
        this.ymax = 120
      }else if(e==2){
        this.echartsObj.thresholdDatas = this.noiseStandard
        this.echartsObj.allDatas = this.noiseList
        this.echartsObj.yAxisName = "dB",
          this.echartsObj.seriesName1 = "噪音",
          this.echartsObj.seriesName2 = '噪音国控值'
        this.ymax = 120
      }
      this.setCharts(this.echartsObj)
    },
    async getList() {
      let res = await this.$https.get(this.$url.realname.screen.check, '');
      console.log(res, '300');
      this.datas = res.data
    },
    async setCharts(echartsObj) {
      var myChart = echarts.init(document.getElementById("main"));

      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        toolbox: {
          show: true,
        },
        grid: {
          top: "18%",
          left: "3%",
          right: "3%",
          bottom: "15%"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00'],
          axisTick: {
            show: false
          },
          splitLine: { show: false },
          axisLabel: {
            interval: 1,
            rotate: 0,
          },
        },
        yAxis: {
          name: echartsObj.yAxisName,
          type: "value",
          nameLocation: 'end',
          max: this.ymax,
          min: 0,
          // interval:5, //值之间的间隔
          axisLine: {
            show: true
          },
          splitLine: { show: false },
        },
        series: [
          {
            name: echartsObj.seriesName1,
            data: echartsObj.allDatas,
            type: "line",
            symbol: "none",
            areaStyle: { color: "#38B1E5" },
          },
          {
            name: echartsObj.seriesName2,
            type: 'line',
            color: 'red',
            symbol: "none",
            data: echartsObj.thresholdDatas,
          },
        ],

      };
      myChart.setOption(option);
    },
    async getNoiseEcharts() {
      let vueTime = new Date();
      let year = vueTime.getFullYear();
      let month = ('0' + (vueTime.getMonth() + 1)).slice(-2);
      let day = ('0' + vueTime.getDate()).slice(-2);
      let formattedTime = `${year}-${month}-${day} 00:00:00`;
      let vueTime1 = new Date();
      vueTime1.setDate(vueTime.getDate() - 1);
      let year1 = vueTime1.getFullYear();
      let month1 = ('0' + (vueTime1.getMonth() + 1)).slice(-2);
      let day1 = ('0' + vueTime1.getDate()).slice(-2);
      let formattedTime1 = `${year1}-${month1}-${day1} 00:00:00`;
      let params = {
        startDate: formattedTime1,
        endDate: formattedTime,
      };
      let res = await this.$https.post(this.$url.realname.screen.list, params);
      console.log(res, '432');
      if (res.code == 200) {

        res.data.map(row => {
          this.pm25List.push(row.avg_pm25)
          this.pm10List.push(row.avg_pm10)

          this.pm10Standard.push(row.avg_pm10_standard)//pm10国际值
          this.pm25Standard.push(row.avg_pm25_standard)//pm25国际值

          this.noiseList.push(row.avg_noise)//噪音
          this.noiseStandard.push(row.avg_noise_standard)//噪音

          this.echartsObj.thresholdDatas = this.pm25Standard
          this.echartsObj.allDatas = this.pm25List

        })
        console.log(this.echartsObj);
        this.setCharts(this.echartsObj)

      }
    },
    async weatherCharts(weatherobj) {
      var myChart = echarts.init(document.getElementById("weather"));
      var option
      option = {
        tooltip: {},
        grid: {
          left: '-4%',
          right: '-4%',
          // bottom: '25%',
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: this.dayarr.filter(m=>{m.daydata}),
            axisLine: {
              //坐标轴轴线相关设置。数学上的x轴
              show: false,
              lineStyle: {
                color: "#f9f9f9",
              },
            },
            axisLabel: {
              show: false,
              //坐标轴刻度标签的相关设置
              textStyle: {
                color: "#d1e6eb",
                margin: 15,
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: weatherobj.min,
            max: weatherobj.max,
            splitLine: {
              show: false,
              lineStyle: {
                color: "#0a3256",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
              margin: 20,
              textStyle: {
                color: "#d1e6eb",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: weatherobj.text  ,
            type: "line",
            label: {
              show: true,
              position: "bottom",
              textStyle: {
                color: "#fff",
              },
            },
            itemStyle: {
              normal: {
                color: "#fff",
              },
            },
            data: weatherobj.didata,
          },
          {
            name: weatherobj.text  ,
            type: "line",
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#fff",
              },
            },
            itemStyle: {
              normal: {
                color: "#fff",
              },
            },
            data: weatherobj.gaodata,
          }
        ],
      };

      myChart.setOption(option);

    },
    async getweatherEcharts() {

      let res = await this.$https.get(this.$url.realname.screen.weather, '');
      if (res.code == 200) {
        res.data.map(row => {
          var dayobj = {
            daydata: '',
            iconData: ''
          }
          var fangliobj = {
            windSpeedNight: ''
          }
          this.wendiList.push(row.tempMin) //温度低
          this.wengaoList.push(row.tempMax) //温度高

          this.wartdiList.push(row.precip) //降水

          var win = row.windScaleDay.split("-")
          this.fengdiList.push(win[0]) //风向
          this.fenggaoList.push(win[1]) //风向

          let currentWeekday = new Date(row.fxDate).getDay();

          let weekdayNames = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
          let currentWeekdayName = weekdayNames[currentWeekday];
          let date = new Date(row.fxDate)
          const month = date.getMonth() + 1;
          const day = date.getDate();
          const formattedDate = `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}`;

          fangliobj.windSpeedNight = row.windSpeedNight
          dayobj.daydata = currentWeekdayName + ' ' + formattedDate
          dayobj.iconData = row.iconDay

          this.dayarr.push(dayobj)
          this.windarr.push(fangliobj)
        })

        this.tabnum1(0);

      }
    },
    async getalarm() {
      let res = await this.$https.get(this.$url.realname.screen.alarmOverall, );
      this.shotlist = res.rows
    },

  }
};
</script>

<style lang="scss" scoped>
.winBox{
  margin: auto;
  width: 2.275rem;
  height: 1.5rem;
  background: #17B879;
  color: #fff;
  border-radius: 1rem;
}

.total {
  .content {
    .right {
      .rc {
        background: rgba(0, 25, 49, 0.5);
        box-shadow: inset 0px 0px 1.25vw 0px rgba(72, 125, 163, 0.5);
        border-radius: 0.42vw;
        border: 0.05vw solid rgba(131, 166, 199, 0.3);
        backdrop-filter: blur(0.73vw);
      }

      .topsingle {
        width: 100%;
        height: 100%;
        background: rgba(0, 25, 49, 0.5);
        box-shadow: inset 0px 0px 1.25vw 0px rgba(72, 125, 163, 0.5);
        border-radius: 0.42vw;
        border: 0.05vw solid rgba(131, 166, 199, 0.3);
        backdrop-filter: blur(0.73vw);

        .biaotou {
          width: 100%;
          background: rgba(0, 192, 254, 0.2);
          display: flex;

          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          margin-top: 10px;

        }

        .jindu {
          width: 100%;
          height: 28%;
          padding: 0 10px;

          .biaoti {
            width: 100%;
            height: 50%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            >p {
              font-family: AlibabaPuHuiTi_2_55_Regular;
              font-size: 12px;
              color: #D9E7FF;
              line-height: 20px;
              text-align: left;
              font-style: normal;

              span {
                font-family: AlibabaPuHuiTi_2_85_Bold;
                font-size: 16px;
                // color: #D9E7FF;
                line-height: 28px;
                text-align: center;
                font-style: normal;
                text-transform: none;
                // background: linear-gradient(to right, red, blue);
                background: linear-gradient(90deg, #05A5E7 0%, #52D9FF 69%, #94DEFF 100%);
                -webkit-background-clip: text;
                background-clip: text;
                color: transparent;

              }
            }

          }

          .jindutiao {
            width: 100%;
            height: 20%;
            background: rgba(0, 192, 254, 0.2);
            border-radius: 100px;
            position: relative;

            .chang {
              height: 100%;
              background: linear-gradient(270deg, #00d5ff 0%, rgba(0, 192, 254, 0) 100%);
              border-radius: 100px;
            }

            .dian {
              width: 6px;
              height: 15px;
              background: #00E7FE;
              box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
              border-radius: 3px;
              position: absolute;
              top: -2px;
            }
          }
        }

        .junzhi {
          width: 100%;
          height: 45%;
          display: flex;
          justify-content: space-around;

          >div {
            width: 24%;
            height: 100%;

            p {
              font-family: AlibabaPuHuiTi_2_85_Bold;
              font-size: 20px;
              // color: #D9E7FF;
              // line-height: 33px;
              text-align: center;
              font-style: normal;
              text-transform: none;
              background: linear-gradient(90deg, #FFFFFF 0%, #4CBAFF 100%);
              // background: linear-gradient(90deg, #05A5E7 0%, #52D9FF 69%, #94DEFF 100%);
              -webkit-background-clip: text;
              background-clip: text;
              color: transparent;
            }

            span {
              margin-left: 14%;
            }
          }
        }

      }

      .weart {
        width: 100%;
        height: 100%;

        .head {
          width: 100%;
          height: 25%;
          display: flex;
          align-items: center;

          justify-content: space-between;
          padding: 1.5%;

          >div {

            text-align: center;
          }

        }

        #weather {
          width: 100%;
          height: 50%;
        }

        .bott {
          width: 100%;
          height: 25%;
          display: flex;
          align-items: center;

          justify-content: space-between;
          padding: 1% 3%;

          >div {

            text-align: center;
          }
        }
      }

      gap: 1.04vw;
    }

    .left {
      .kongbox {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            > img {
              width: 30%;
              margin-bottom: 0.625rem;
            }
          }
      .shotsingle {
        img {
          width: 3.65vw;
          height: 3.65vw;
        }

        height: 6.67vw;
        padding: 1.73vw 0.73vw;
        background: #16385e;
        border-radius: 0.42vw;
        gap: 0.63vw;
      }

      width: 17.19vw;
      height: 100%;
      background: rgba(0, 25, 49, 0.5);
      box-shadow: inset 0px 0px 1.25vw 0px rgba(72, 125, 163, 0.5);
      border-radius: 0.42vw;
      border: 0.05vw solid rgba(131, 166, 199, 0.3);
      backdrop-filter: blur(0.73vw);
    }

    padding-left: 10.89vw;
    padding-right: 1.04vw;
    margin-top: 1.04vw;
    gap: 1.04vw;
  }
.handled{
   background:linear-gradient( 56deg, #00B4FB 0%, #0254A0 100%)  !important;
}
  background: url("../assets/image/bgstaff.png") no-repeat;
}
</style>
